


<template>
    <div class="favourites-container">
        <v-btn
            depressed
            @click="addOrRemove()"
            :color="isFavourite() ? 'red' : '#808080'"
        >

            <span class="sr-only">{{ !isFavourite() ? "Add To Favourites" : "Remove from Favourites"}}</span>
            <v-icon v-if="$route.name == 'favourites'" color="white" dark>
                mdi-delete
            </v-icon>
            <v-icon v-else color="white" dark>
                mdi-heart
            </v-icon>
        </v-btn>
    </div>

</template>

<script>
//  import hubbdata from "@/hubbdata";
import favourites from "@/favourites";



export default {
    name: "FavouritesButton",
    props: {
        item: Object,
    },
    methods: {
        addOrRemove(){
           if (favourites.getters.isFavouriteInList(this.item)) {
                favourites.commit("removeFavourite", this.item)
           }
           else {
               favourites.commit("addFavourite", this.item)
           }
        },

        isFavourite() {
            return favourites.getters.isFavouriteInList(this.item)
        }
    },
    created() {
        this.isFavourite()
    }
}

</script>

<style lang="scss" scoped>
    .favourites-container {
        position: absolute;
        right: 0;
        z-index: 2
        ;
    }

    .v-btn {
        height: 55px !important;
        width: 55px !important;
        min-height: 55px !important;
        min-width: 55px !important;
        border-radius: 0px;
        border-bottom-left-radius: 5px;
    }

</style>
